import {type LogsPageLocation} from './logsPageEvents';
import {makeTrackEvent} from './makeTrackEvent';

export type FileDownloadLocation =
  | LogsPageLocation // Log files can be downloaded here.
  | 'run-files'
  | 'sweep-files'
  | 'group-files';
export type FileDownloadEvent = {
  fileType: string;
  isMultipartLogsFile?: boolean;
  location: FileDownloadLocation;
};

export const trackFileDownload = makeTrackEvent<
  FileDownloadEvent,
  {
    fileType: {
      description: 'the file extension/type';
      exampleValues: ['json', 'log', 'yaml'];
    };
    isMultipartLogsFile: {
      description: 'whether a log file is one part of a multipart upload';
    };
    location: {
      description: 'page or section where the file download was initiated';
      exampleValues: ['run-files', 'run-logs', 'sweep-logs'];
    };
    _description: 'Tracks file downloads across the application';
    _location: 'downloads';
    _motivation: 'understand file download patterns and usage';
  }
>('File download');
